import { withSvgIcon } from './withSvgIcon';

export const Logout = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H11H12V19H11H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5H11H12V3H11H6ZM10 11H9V13H10H17.5858L15.2929 15.2929L14.5858 16L16 17.4142L16.7071 16.7071L20.7071 12.7071C21.0976 12.3166 21.0976 11.6834 20.7071 11.2929L16.7071 7.29289L16 6.58579L14.5858 8L15.2929 8.70711L17.5858 11L10 11Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
